$(document).ready(function ($) {

    // klik na SVG podlaží
    $('svg g[data-floor]').on('click', function () {
        const floor = $(this).data('floor');
        switchFloor(floor);
    });

    // prepínanie cez select
    $('#select-apartments-environment').on('change', function () {
        const floor = $(this).val();
        switchFloor(floor);
    });

    // funkcia na prepínanie podlažia
    function switchFloor(floor) {
        $('.floor-plan').removeClass('is-active');
        $('.floor-plan[data-floor="' + floor + '"]').addClass('is-active');

        // synchronizácia selectu, aby bol rovnaký aj pri kliknutí na SVG
        $('#select-apartments-environment').val(floor);

        if (floor == 1) {
            $('#list-apartments').hide();
            $('#list-parking').attr('data-filter-environment', 'true');
            $('#list-parking').show();
        } else {
            $('#list-parking').hide();
            $('#list-apartments').attr('data-filter-floor', floor);
            $('#list-apartments').show();
        }
    }

    // prepínanie environment cez button/select
    $('#btn-environment').on('click', function () {
        const current = $('[data-filter-environment]').attr('data-filter-environment');
        setEnvironment(current === 'true' ? 'false' : 'true');
    });

    $('#select-environment').on('change', function () {
        setEnvironment($(this).val());
    });

    function setEnvironment(value) {
        const el = $('[data-filter-environment]');
        const btn = $('#btn-environment');
        const select = $('#select-environment');
        const headline = $('#headline-1');

        // uloženie stavu
        el.attr('data-filter-environment', value);

        // sync button text
        btn.text(value === 'true' ? btn.data('text-true') : btn.data('text-false'));

        // sync select
        select.val(value);

        const svgs = $('.floor-plan--body svg');
        if (value === 'true') {
            svgs.eq(0).show();
            svgs.eq(1).hide();
        } else {
            svgs.eq(0).hide();
            svgs.eq(1).show();
        }

        headline.text(value === 'true' ? headline.data('text-true') : headline.data('text-false'));
    }

    // scroll pri kliknutí na preview SVG – natívne, jQuery animate sa bije s html { scroll-behavior: smooth }
    $('.offer--floor--preview--options svg').on('click', function () {
        const header = $('.main-header').outerHeight() || 0;

        window.scrollTo({
            top: $('.offer--floor--plan').offset().top - header,
            behavior: 'smooth'
        });
    });

    // odkaz na apartmán
    $('[data-apartment-href]').on('click', function () {
        const href = $(this).data('apartment-href');
        if (href && href.includes('/ponuka/')) {
            window.location.href = href;
        }
    });
});